<div class="tpl3pl-page-container">
	<p class="text-muted mb-3">Send an Inbound order so the 3PL knows which PO and lines are expected. Do this before expecting inventory at the 3PL (see 3PL flow in docs/3PL_FLOW.md).</p>
	<div class="tpl3pl-toolbar">
		<div class="tpl3pl-toolbar-filters">
			<mat-form-field appearance="fill" class="tpl3pl-field mr-2">
				<mat-label>PO number</mat-label>
				<input matInput [ngModel]="purchaseOrderNo" readonly placeholder="Get next PO">
				<button mat-icon-button matSuffix (click)="fetchNextPo()" [disabled]="poLoading" matTooltip="Get next PO from system">
					<mat-spinner *ngIf="poLoading" diameter="24"></mat-spinner>
					<mat-icon *ngIf="!poLoading">refresh</mat-icon>
				</button>
			</mat-form-field>
			<mat-form-field appearance="fill" class="tpl3pl-field mr-2">
				<mat-label>Order date</mat-label>
				<input matInput type="date" [(ngModel)]="orderDate">
			</mat-form-field>
			<mat-form-field appearance="fill" class="tpl3pl-field mr-2">
				<mat-label>Warehouse</mat-label>
				<input matInput [(ngModel)]="warehouse" placeholder="CM, PICO, FW, NJ">
			</mat-form-field>
		</div>
		<div class="tpl3pl-toolbar-actions">
			<button mat-raised-button color="primary" (click)="openViewRawSend()" matTooltip="View payload and send to 3PL">
				<mat-icon>visibility</mat-icon> View raw request / response
			</button>
			<button mat-stroked-button (click)="openManualInboundRaw()" matTooltip="Open raw request/response with current form payload">
				<mat-icon>code</mat-icon> Manual Inbound (raw)
			</button>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-md-12">
			<mat-form-field appearance="fill" class="tpl3pl-field w-100">
				<mat-label>Vendor (search to select and fill address)</mat-label>
				<input matInput [ngModel]="vendorSearchInput" (ngModelChange)="onVendorSearchInput($event)" [matAutocomplete]="vendorAuto" placeholder="Type vendor ID or name">
				<mat-autocomplete #vendorAuto="matAutocomplete" [displayWith]="vendorDisplayFn" (optionSelected)="onVendorSelected($event.option.value)">
					<mat-option *ngFor="let v of vendorOptions" [value]="v">{{ v.supplierid }} - {{ v.suppname }}</mat-option>
				</mat-autocomplete>
			</mat-form-field>
		</div>
		<div class="col-md-8">
			<mat-form-field appearance="fill" class="tpl3pl-field w-100">
				<mat-label>Address</mat-label>
				<input matInput [(ngModel)]="vendorAddress1" placeholder="Address line 1">
			</mat-form-field>
		</div>
		<div class="col-md-4">
			<mat-form-field appearance="fill" class="tpl3pl-field w-100">
				<mat-label>Address 2</mat-label>
				<input matInput [(ngModel)]="vendorAddress2" placeholder="Optional">
			</mat-form-field>
		</div>
		<div class="col-md-4">
			<mat-form-field appearance="fill" class="tpl3pl-field w-100">
				<mat-label>City</mat-label>
				<input matInput [(ngModel)]="vendorCity">
			</mat-form-field>
		</div>
		<div class="col-md-2">
			<mat-form-field appearance="fill" class="tpl3pl-field w-100">
				<mat-label>State</mat-label>
				<input matInput [(ngModel)]="vendorState" placeholder="ST">
			</mat-form-field>
		</div>
		<div class="col-md-2">
			<mat-form-field appearance="fill" class="tpl3pl-field w-100">
				<mat-label>ZIP</mat-label>
				<input matInput [(ngModel)]="vendorZipCode" placeholder="12345">
			</mat-form-field>
		</div>
		<div class="col-md-2">
			<mat-form-field appearance="fill" class="tpl3pl-field w-100">
				<mat-label>Country</mat-label>
				<input matInput [(ngModel)]="vendorCountry" placeholder="US">
			</mat-form-field>
		</div>
	</div>
	<div class="mb-2">
		<h5 class="mb-2">Line items</h5>
		<p class="text-muted small mb-2">Same SKUs as used for 3PL inventory export and SKU push. Load them below or add manually.</p>
		<div class="row align-items-end mb-2">
			<div class="col-auto">
				<mat-form-field appearance="fill" class="tpl3pl-field mb-0 mr-2">
					<mat-label>Default qty (for load)</mat-label>
					<input matInput type="number" min="1" [(ngModel)]="defaultQtyForLoad" (ngModelChange)="onDefaultQtyChange()">
				</mat-form-field>
			</div>
			<div class="col-auto">
				<mat-form-field appearance="fill" class="tpl3pl-field mb-0 mr-2">
					<mat-label>Search SKU (optional)</mat-label>
					<input matInput [(ngModel)]="skuLoadSearch" placeholder="Filter when loading">
				</mat-form-field>
			</div>
			<div class="col-auto">
				<button mat-stroked-button (click)="loadSkusFromInventoryScope()" [disabled]="loadSkusLoading" matTooltip="Load in-scope SKUs (same list as inventory export / SKU push)">
					<mat-spinner *ngIf="loadSkusLoading" diameter="20"></mat-spinner>
					<mat-icon *ngIf="!loadSkusLoading">inventory_2</mat-icon>
					{{ loadSkusLoading ? 'Loading…' : 'Load SKUs from inventory scope' }}
				</button>
			</div>
		</div>
		<table class="table table-sm table-bordered">
			<thead>
				<tr>
					<th>SKU (itemNumber)</th>
					<th>Qty</th>
					<th>Description</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let line of lines; let i = index">
					<td><input class="form-control form-control-sm" [(ngModel)]="line.itemNumber" placeholder="SKU" name="item_{{i}}" /></td>
					<td><input type="number" min="1" class="form-control form-control-sm" [(ngModel)]="line.qtyOrdered" name="qty_{{i}}" /></td>
					<td><input class="form-control form-control-sm" [(ngModel)]="line.itemDescription" placeholder="Required" name="desc_{{i}}" required /></td>
					<td><button mat-icon-button (click)="removeLine(i)" [disabled]="lines.length <= 1" matTooltip="Remove line"><mat-icon>remove_circle_outline</mat-icon></button></td>
				</tr>
			</tbody>
		</table>
		<button mat-stroked-button (click)="addLine()"><mat-icon>add</mat-icon> Add line</button>
	</div>

	<mat-expansion-panel class="mt-4">
		<mat-expansion-panel-header>
			<mat-panel-title>Receipt by PO</mat-panel-title>
			<mat-panel-description>Query receipt details by PO number. Reconcile into ERP; confirm isClosed = true when fully received.</mat-panel-description>
		</mat-expansion-panel-header>
		<div class="receipt-lookup mb-3">
			<mat-form-field appearance="fill" class="tpl3pl-field mr-2">
				<mat-label>PO number</mat-label>
				<input matInput [(ngModel)]="receiptLookupPo" (keyup.enter)="lookupReceiptByPo()" placeholder="Enter PO to look up">
			</mat-form-field>
			<button mat-raised-button color="primary" (click)="lookupReceiptByPo()" [disabled]="receiptLookupLoading">
				<mat-spinner *ngIf="receiptLookupLoading" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!receiptLookupLoading">search</mat-icon>
				{{ receiptLookupLoading ? 'Loading…' : 'Look up receipt' }}
			</button>
		</div>
		<div *ngIf="receiptError" class="alert alert-warning">{{ receiptError }}</div>
		<div *ngIf="receiptData && receiptData.length > 0">
			<div *ngFor="let rec of receiptData" class="receipt-record mb-4">
				<div class="d-flex align-items-center mb-2">
					<strong>PO: {{ rec.orderNo ?? rec.orderno ?? '-' }}</strong>
					<span class="ml-2 badge" [ngClass]="(rec.isClosed ?? rec.isclosed) ? 'badge-success' : 'badge-secondary'">
						{{ (rec.isClosed ?? rec.isclosed) ? 'Closed' : 'Open' }}
					</span>
				</div>
				<div *ngFor="let batch of (rec.Inbound_Items || rec.inbound_items || [])" class="receipt-batch mb-3 pl-3">
					<div class="text-muted small mb-1">Receipt {{ batch.receiptNo ?? batch.receiptno ?? '-' }} · {{ batch.receiptDate ?? batch.receiptdate ?? '-' }}</div>
					<table class="table table-sm table-bordered">
						<thead>
							<tr>
								<th>Line</th>
								<th>SKU</th>
								<th>Lot</th>
								<th>Qty received</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let line of (batch.Inbound_Item || batch.inbound_item || [])">
								<td>{{ line.itemLine ?? line.itemline ?? '-' }}</td>
								<td>{{ line.sku ?? '-' }}</td>
								<td>{{ line.lotNumber ?? line.lotnumber ?? '-' }}</td>
								<td>{{ line.qtyReceived ?? line.qtyreceived ?? '-' }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</mat-expansion-panel>
</div>
